import React from 'react';
import { Box, Grid, GridProps, Toolbar, useMediaQuery, useTheme } from '@material-ui/core';
import { TopProductsList, UnpopularProductsList } from '../TopProducts';
import { TopCategoriesList, UnpopularCategoriesList } from '../TopCategories';
import { TopEmployeesList } from '../TopEmployees';
import { DrawerWidthGrid, FixedBox, GridItemMinusDrawer, PaddedContainer } from '../../../../ui-kit';
import { Chart } from '../Chart';
import { TopTableCard } from '../TopTable';
import { PendingOrders } from '../PendingOrders';
import { CancelVoidDiscountList } from '../CancelVoidDiscount';
import ProtectedComponent from '../../../../utils/routes/ProtectedComponent';
import { VenueType } from '../../../../generated/graphql';
import { useUser } from '../../../../utils/hooks/auth';
import { checkVenueTypeAccess } from '../../../../utils';
import { DateFilterContainer } from '../../../shared';
import { TotalIncome } from '../TotalIncome';
import { AverageOrderStatistics } from '../AverageOrderStatistics';
import { DashboardToolbar } from './DashboardToolbar';

const Dashboard = () => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const isTablet = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
    const { user: { venueType } } = useUser();
    const itemSize = checkVenueTypeAccess([VenueType.Restaurant], venueType) ? 'auto' : 12;

    const GridItemLarge = isDesktop
        ? GridItemMinusDrawer
        : (props: Omit<GridProps, 'item'>) => <Grid xs={12} item {...props} />;
    const GridItemSmall = isDesktop
        ? DrawerWidthGrid
        : (props: Omit<GridProps, 'item'>) => <Grid xs={12} item {...props} />;

    return (
        <>
            <Toolbar />
            <FixedBox>
                <DashboardToolbar />
            </FixedBox>
            <Box my={4}>
                <PaddedContainer spacing={3}>
                    <Grid style={{ margin: 0 }} spacing={3} container xs={12}>
                        <Grid item md={3} style={{ order: 1 }} sm={6} xs={12}>
                            <TotalIncome />
                        </Grid>
                        <Grid item md={6} style={{ order: isTablet ? 3 : 2 }} xs={12}>
                            <Chart />
                        </Grid>
                        <Grid item md={3} style={{ order: isTablet ? 2 : 3 }} sm={6} xs={12}>
                            <AverageOrderStatistics />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={3}>
                            <GridItemLarge md={itemSize} xs={12}>
                                <TopProductsList />
                            </GridItemLarge>
                            <ProtectedComponent allowedVenueTypes={[VenueType.Restaurant]}>
                                <GridItemSmall>
                                    <TopTableCard />
                                </GridItemSmall>
                            </ProtectedComponent>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={3}>
                            <GridItemLarge md={itemSize} xs={12}>
                                <TopCategoriesList />
                            </GridItemLarge>
                            <ProtectedComponent allowedVenueTypes={[VenueType.Restaurant]}>
                                <GridItemSmall>
                                    <PendingOrders />
                                </GridItemSmall>
                            </ProtectedComponent>
                        </Grid>
                    </Grid>
                    <ProtectedComponent allowedVenueTypes={[VenueType.Restaurant]}>
                        <Grid item xs={12} md={6}>
                            <TopEmployeesList />
                        </Grid>
                    </ProtectedComponent>
                    <Grid item xs={12} md={6}>
                        <CancelVoidDiscountList />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <UnpopularCategoriesList />
                    </Grid>
                    <ProtectedComponent allowedVenueTypes={[VenueType.Restaurant]}>
                        <Grid item xs={12} md={6}>
                            <UnpopularProductsList />
                        </Grid>
                    </ProtectedComponent>
                </PaddedContainer>
            </Box>
        </>
    );
};

export default () => (
    <DateFilterContainer disableWrapper>
        <Dashboard />
    </DateFilterContainer>
);
